<template>
  <footer class="footer-container">
    <div v-if="!hideLinks" class="footer-links">
      <a href="https://oxoformdocs.fra1.digitaloceanspaces.com/69257aa7a4d36ed2e71ec392/reglement.pdf" target="_blank" class="footer-link">Règlement</a>
      <span class="separator">|</span>
      <router-link to="/mentions-legales" class="footer-link">Mentions légales</router-link>
      <span class="separator">|</span>
      <a href="https://www.cartenoire.fr/fr/vie-privee" target="_blank" class="footer-link">Politique de Protection de la Vie Privée</a>
      <span class="separator">|</span>
  
      <router-link to="/contact" class="footer-link">Nous contacter</router-link>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
  props: {
    hideLinks: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.footer-container {
  background-color: #fff;
  padding: 20px;
  min-height: 60px;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.footer-link {
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 16px;
  color: #000;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #333;
}

.separator {
  color: #999;
  font-size: 16px;
}
</style>
